var _style, _circle, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChewyWishlist = function SvgChewyWishlist(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145.8 145.8",
    style: {
      enableBackground: "new 0 0 145.8 145.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.chewycircle{fill:#69B4E5;}\n\t.chewypaw{fill:#FEFDFD;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "chewycircle",
    cx: 73.3,
    cy: 72.7,
    r: 72.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "chewypaw",
    d: "M61.8,57.6c2.3-5.5,0.7-12.2-3.3-16.4c-1.7-1.8-4-3.2-6.5-3.3c-12.1-0.4-6.7,20.3,1.3,23.3 C57.3,62.8,60.1,61.6,61.8,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chewypaw",
    d: "M34.7,70.8c-0.4,1.3-0.5,2.8-0.2,4.5c0.4,2.3,0.9,4.7,2,6.8c1.7,3.3,6.9,7.3,10.7,5.4c2.9-1.4,4.6-4.4,4.5-7.6 c0-4.1-1.7-8.1-4.7-10.9C42.3,64.3,36.2,65.7,34.7,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chewypaw",
    d: "M75,55.2c4,2.7,6.9,1.6,8.5-2.9c2.5-6.9,0.4-14.2-6.4-17.7c-6.6-3.5-10,4.8-9.1,10.2 C68.6,49.1,71.2,52.9,75,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chewypaw",
    d: "M98.7,73.4c-4.5-1.8-9.1-3.6-13.5-5.6c-4.7-2.2-9.6-2.7-15.6-1.9c-5.1,0.8-10.3,6.2-10.7,12.8 c-0.3,5.8-0.8,11.6-1.3,17.4c-0.4,4.4,1,8.1,5,10.3c4,2.3,8.4,2.2,11.5-0.7c6.8-6.2,15.2-10.4,24.2-12.3c4.7-1,7.2-5.2,7.3-10.2 C105.8,78.3,103.2,75.2,98.7,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chewypaw",
    d: "M99.3,62.4c4.2-0.6,7-3.8,6.6-7.3c-0.7-4.8-6.7-10-10.8-9.3c-3.5,0.6-5.7,4.1-5.1,8 C90.7,59.4,94.7,63.1,99.3,62.4z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChewyWishlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chewy-wishlist.7370cb48.svg";
export { ForwardRef as ReactComponent };